<template>
  <div class="mic-com point-trade-container">
    <div class="point-trade" :style="goodsStyle">
      <GoodsChunk v-for="chunk in chunkList"
                  chunk-type="point_trade"
                  :key="chunk.key"
                  :config="config"
                  :data="chunk"
                  :preview="preview">
        <template v-slot="{goods, index}">
          <GoodsCard
                  :index="index"
                  :key="goods.guid"
                  :config="config"
                  :data="goods"/>
        </template>
      </GoodsChunk>
      <div class="point-trade-all-btn"
           v-if="config.show_all_btn&&config.goods_from===1"
           :style="{marin: config.goods_margin / 2 + 'px'}">
        <van-button size="large" :url="config.more_link_url">查看全部</van-button>
      </div>
      <div class="empty" v-if="!chunkList.length">
        <van-image :src="goods_empty" style="height: 250px;"/>
      </div>
    </div>
  </div>
</template>

<script>
  import * as shop from '@/api/shop';
  import GoodsCard from "./GoodsCard";
  import ChunkList from '../mixins/ChunkList';
  import Common from '../mixins/Common';

  export default {
	name: 'PointTrade',
	props: {},
	mixins: [Common, ChunkList],
	components: {GoodsCard},
	data() {
	  return {
		chunkList: [],
		observerKeys: [
		  'config.goods_from',
		  'config.guids',
		  'config.goods_number'
		],
		request: shop.getPointList
	  };
	},
	created() {
	  this.observerWhenPreview();
	  this.createChunkList();
	},
	methods: {
	  getQuery(query) {
		return {
		  ...query,
		  order: this.config.order_rule
		};
	  }
	},
	computed: {}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .point-trade-container {
    overflow: hidden;

    .point-trade {
      overflow: hidden;
    }

    .point-trade-all-btn {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
</style>
